<template>
  <div class="section-block">
    <div>
      <BaseElForm ref="formRef" :model="formData">
        <div class="flex flex-wrap justify-bwtween" style="gap: 24px">
          <BaseElFormItem label="服務項目" prop="service">
            <BaseDataSelect
              :value.sync="formData.service"
              :dataList="resourceData.service"
              :filterable="false"
              labelKey="name"
              valueKey="id"
              @change="onSelectService"
            />
          </BaseElFormItem>
          <BaseElFormItem label="子服務項目" prop="subService">
            <BaseDataSelect
              :value.sync="formData.subService"
              :dataList="resourceData.subService"
              :disabled="!resourceData.subService.length"
              :filterable="false"
              labelKey="name"
              valueKey="id"
              @change="onSelectSubService"
            />
          </BaseElFormItem>
          <!-- 附加服務 -->
          <BaseElFormItem label="附加服務" prop="attachService">
            <BaseDataSelect
              :value.sync="formData.attachService"
              :dataList="resourceData.attachService"
              :disabled="!resourceData.attachService.length"
              multiple
              labelKey="name"
              valueKey="id"
            />
          </BaseElFormItem>
          <!-- 服務人員 -->
          <BaseElFormItem label="服務人員" prop="serviceUnit">
            <BaseDataSelect
              :value.sync="formData.serviceUnit"
              :dataList="resourceData.serviceUnit"
              :disabled="!resourceData.serviceUnit.length"
              :filterable="false"
              labelKey="name"
              valueKey="id"
            />
          </BaseElFormItem>
          <!-- 預約設備 -->
          <BaseElFormItem label="預約設備" prop="serviceResource">
            <BaseDataSelect
              :value.sync="formData.serviceResource"
              :dataList="resourceData.serviceResource"
              :disabled="!resourceData.serviceResource.length"
              :filterable="false"
              labelKey="name"
              valueKey="id"
            />
          </BaseElFormItem>
          <!-- datetime picker -->
          <BaseElFormItem label="預約時間" prop="startAt">
            <el-date-picker
              v-model="formData.startAt"
              type="datetime"
              placeholder="選擇日期時間"
              :clearable="true"
              :format="'yyyy-MM-dd HH:mm'"
            />
          </BaseElFormItem>
        </div>
      </BaseElForm>
      <div class="flex justify-end">
        <BaseElButton plain style="width: 150px;" @click="onClear">清除</BaseElButton>
        <BaseElButton type="primary" style="width: 150px;" @click="onCheck">檢查</BaseElButton>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckAppointmentTimeAvailability } from '@/api/reservation'
import { FindService } from '@/api/service'
import BaseDataSelect from '@/components/Select/BaseDataSelect.vue'
import { useShop } from '@/use/shop'
import { map, get } from 'lodash'

import { defineComponent, inject } from 'vue'
export default defineComponent({
  name: 'AppointmentTimeDebuggerFilterBlock',
  components: {
    BaseDataSelect,
  },
  setup (props, { emit }) {
    const formData = inject('formData')
    const detailData = inject('detailData')
    const resourceData = inject('resourceData')
    const resultData = inject('resultData')
    const loading = inject('loading')
    const { shopId } = useShop()

    const onSelectService = async (service) => {
      if (!service) return

      formData.subService = null
      formData.attachService = []
      formData.serviceUnit = null
      formData.serviceResource = null
      formData.startAt = null

      const [res, errMsg] = await FindService({
        shopId: shopId.value,
        id: service.id,
      })
      if (errMsg) {
        window.$message.error(errMsg)
        return
      }
      detailData.service = res
      resourceData.subService = get(res, 'AppointmentSubServices', [])
      resourceData.serviceUnit = get(res, 'AppointmentUnits', [])
      resourceData.attachService = get(res, 'AppointmentServiceAttaches', [])
      resourceData.serviceResource = get(res, 'ResourceItems', [])
    }

    const onSelectSubService = async (subService) => {
      detailData.subService = subService
    }

    const onCheck = async () => {
      if (loading.value) return
      loading.value = true
      const [res, errMsg] = await CheckAppointmentTimeAvailability({
        shopId: shopId.value,
        appointmentServiceId: get(formData.service, 'id'),
        appointmentSubServiceId: get(formData.subService, 'id'),
        appointmentServiceAttachIds: map(formData.attachService, 'id'),
        appointmentUnitId: get(formData.serviceUnit, 'id'),
        resourceItemId: get(formData.serviceResource, 'id'),
        startAt: formData.startAt,
      })
      loading.value = false
      if (errMsg) {
        window.$message.error(errMsg)
        return
      }

      emit('checked', res)
    }

    const onClear = () => {
      formData.service = null
      formData.subService = null
      formData.attachService = []
      formData.serviceUnit = null
      formData.serviceResource = null
      formData.startAt = null

      resultData.value = null

      detailData.service = null
      detailData.subService = null
      detailData.serviceUnit = null
      detailData.serviceResource = null
      resultData.value = null
    }

    return {
      formData,
      detailData,
      resourceData,
      onSelectService,
      onSelectSubService,
      onClear,
      onCheck,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
